import i18next from "i18next";

/**
 * Перевод строк общих компонентов (`shared/**`) вне React-контекста:
 * класс-компоненты (FormBuilder), хуки без доступа к `useTranslation`
 * и значения по умолчанию, вычисляемые в момент рендера.
 *
 * Общие компоненты рендерятся в двух приложениях с разными i18n-режимами:
 *
 * - партнёрский кабинет тянет namespace `partner` с бэкенда (сид
 *   `backend/src/migrations/data/partnerSeed/sharedComponents.ts`), там ключи
 *   `shared.*` находятся и переводятся на ru/en;
 * - админка целиком русская и своего словаря для этих ключей не держит
 *   (`admin/app/providers/i18n.ts`), поэтому русский текст передаётся
 *   `defaultValue`, он и остаётся видимым там один в один как раньше.
 *
 * Вызов идёт через глобальный синглтон i18next, который инициализируют оба
 * приложения, поэтому `defaultNS` подставляется правильный. Резолвить нужно
 * лениво, в момент рендера: на этапе загрузки модуля инстанс ещё не поднят
 * и `t` вернул бы сам ключ.
 */
export function tShared(key: string, defaultValue: string): string {
  // До init() у i18next нет ни ресурсов, ни translator'а, и `t` возвращает
  // undefined, хотя типизирован как string. Подстраховываемся `??`, иначе в
  // разметку утёк бы undefined.
  return i18next.t(key, { defaultValue }) ?? defaultValue;
}

/**
 * tShared с подстановкой `{{name}}`: i18next интерполирует и перевод, и
 * defaultValue; до init подстановку делаем сами.
 */
export function tSharedWith(
  key: string,
  defaultValue: string,
  vars: Record<string, string | number>
): string {
  // Строка уходит в React-текст, который экранирует сам: экранирование
  // i18next дало бы на экране «O&#39;Neil &amp; Co» (оба приложения и так
  // выключают его в init, здесь явно на случай другой настройки).
  const translated = i18next.t(key, {
    defaultValue,
    ...vars,
    interpolation: { escapeValue: false },
  }) as string | undefined;
  return (
    translated ??
    defaultValue.replace(/\{\{(\w+)\}\}/g, (_, k: string) =>
      String(vars[k] ?? "")
    )
  );
}
